/**
 * EHV-132: Track resolution workflow status (Offen / In Bearbeitung / Abgeschlossen)
 * on Beschlusssammlung list + resolution edit pages.
 */

const LuxResolutionWorkflow = {
  STATUSES: [
    { value: 'OPEN', label: 'Offen' },
    { value: 'IN_PROGRESS', label: 'In Bearbeitung' },
    { value: 'RESOLVED', label: 'Abgeschlossen' },
  ],
}

/** Ant Design–like select (native select + CSS) so it matches Beschlussstatus */
function LuxResolutionWorkflow_ensureSelectStyles() {
  if (document.getElementById('lux-resolution-workflow-styles')) return
  const style = document.createElement('style')
  style.id = 'lux-resolution-workflow-styles'
  style.textContent = `
    .lux-resolution-ant-select-mimic {
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      box-sizing: border-box;
      width: 100%;
      margin: 0;
      padding: 0 32px 0 11px;
      height: 32px;
      font-size: 14px;
      font-weight: 500;
      line-height: 32px;
      color: rgba(0, 0, 0, 0.88);
      background-color: #fff;
      border: 1px solid #d9d9d9;
      border-radius: 2px;
      cursor: pointer;
      outline: none;
      font-family: inherit;
      background-image: url("data:image/svg+xml,%3Csvg width='10' height='5' viewBox='0 0 10 5' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 0L5 5L10 0H0Z' fill='%23000000'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: right 11px center;
    }
    .lux-resolution-ant-select-mimic:hover {
      border-color: #4096ff;
    }
    .lux-resolution-ant-select-mimic:focus {
      border-color: #4096ff;
      box-shadow: 0 0 0 2px rgba(5, 145, 255, 0.06);
    }
    .lux-resolution-workflow-bearbeitung .lux-resolution-workflow-select-wrap {
      flex: 1;
      min-width: 0;
    }
    .lux-resolution-ant-select-mimic:disabled {
      color: rgba(0, 0, 0, 0.25);
      background-color: rgba(0, 0, 0, 0.04);
      border-color: #d9d9d9;
      cursor: not-allowed;
      opacity: 1;
    }
    .lux-resolution-ant-select-mimic:disabled:hover,
    .lux-resolution-ant-select-mimic:disabled:focus {
      border-color: #d9d9d9;
      box-shadow: none;
    }
    /* When we render full Ant <div class="ant-select ...">, keep native select clickable but invisible */
    .lux-resolution-ant-select-wrap {
      position: relative;
      width: 100%;
    }
    .lux-resolution-ant-native-overlay {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
    }
    .lux-resolution-ant-native-overlay:disabled {
      cursor: not-allowed;
    }
  `
  document.head.appendChild(style)
}

function LuxResolutionWorkflow_labelForStatus(status) {
  const item = LuxResolutionWorkflow.STATUSES.find((s) => s.value === status)
  return item ? item.label : 'Offen'
}

function LuxResolutionWorkflow_createAntSelectMimic(currentStatus) {
  LuxResolutionWorkflow_ensureSelectStyles()

  const wrap = document.createElement('div')
  wrap.className = 'lux-resolution-ant-select-wrap'

  const ant = document.createElement('div')
  ant.className =
    'ant-select ant-select-in-form-item Select ant-select-single ant-select-show-arrow'

  const selector = document.createElement('div')
  selector.className = 'ant-select-selector'

  // Match Impower markup structure (search span + selection item)
  const search = document.createElement('span')
  search.className = 'ant-select-selection-search'
  const searchInput = document.createElement('input')
  searchInput.type = 'search'
  searchInput.autocomplete = 'off'
  searchInput.className = 'ant-select-selection-search-input'
  searchInput.setAttribute('role', 'combobox')
  searchInput.setAttribute('aria-haspopup', 'listbox')
  searchInput.readOnly = true
  searchInput.setAttribute('unselectable', 'on')
  searchInput.value = ''
  searchInput.style.opacity = '0'
  selector.appendChild(search)
  search.appendChild(searchInput)

  const item = document.createElement('span')
  item.className = 'ant-select-selection-item'
  item.textContent = LuxResolutionWorkflow_labelForStatus(currentStatus)
  item.title = item.textContent
  selector.appendChild(item)

  const arrow = document.createElement('span')
  arrow.className = 'ant-select-arrow'
  arrow.setAttribute('unselectable', 'on')
  arrow.setAttribute('aria-hidden', 'true')
  arrow.style.userSelect = 'none'
  arrow.innerHTML =
    '<span role="img" class="anticon"><svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 0L5 5L10 0H0Z" fill="white"></path></svg></span>'

  ant.appendChild(selector)
  ant.appendChild(arrow)
  wrap.appendChild(ant)

  return { wrap, ant, selectionItemEl: item, searchInputEl: searchInput }
}

/** Beschlussstatus <div class="ant-select … ant-select-disabled"> — when present, form is read-only. */
function LuxResolutionWorkflow_findBeschlussAntSelect(beschlussSelectRoot) {
  if (!beschlussSelectRoot) return null
  return beschlussSelectRoot.querySelector('.ant-select')
}

function LuxResolutionWorkflow_isResolutionFormLocked(beschlussSelectRoot) {
  const ant = LuxResolutionWorkflow_findBeschlussAntSelect(beschlussSelectRoot)
  if (!ant) return true
  return ant.classList.contains('ant-select-disabled')
}

function LuxResolutionWorkflow_syncBearbeitungSelectLockedState(beschlussSelectRoot, ourSelect, ourAntSelect) {
  if (!ourSelect) return
  const locked = LuxResolutionWorkflow_isResolutionFormLocked(beschlussSelectRoot)
  ourSelect.disabled = locked
  ourSelect.setAttribute('aria-readonly', locked ? 'true' : 'false')
  if (ourAntSelect && ourAntSelect.classList) {
    ourAntSelect.classList.toggle('ant-select-disabled', locked)
    ourAntSelect.classList.toggle('read-only', locked)
  }
}

function LuxResolutionWorkflow_watchBeschlussLockState(beschlussSelectRoot, ourSelect, ourAntSelect) {
  const run = () =>
    LuxResolutionWorkflow_syncBearbeitungSelectLockedState(
      beschlussSelectRoot,
      ourSelect,
      ourAntSelect
    )
  run()
  if (!beschlussSelectRoot || typeof MutationObserver === 'undefined') return
  const obs = new MutationObserver(run)
  obs.observe(beschlussSelectRoot, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class', 'disabled'],
  })
}

function LuxResolutionWorkflow_authHeaders() {
  const token = JSON.parse(localStorage.getItem('auth') || '{}')?.token
  if (!token) return null
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  }
}

async function LuxResolutionWorkflow_fetchStatuses(propertyHrId) {
  const headers = LuxResolutionWorkflow_authHeaders()
  if (!headers) return {}
  const res = await fetch(
    `${baseApiUrl}/api/impowerX/resolution-workflow-status?propertyHrId=${encodeURIComponent(propertyHrId)}`,
    { headers }
  )
  if (!res.ok) return {}
  const data = await res.json()
  return data.statuses && typeof data.statuses === 'object' ? data.statuses : {}
}

async function LuxResolutionWorkflow_saveStatus(propertyHrId, resolutionRecordNumber, status) {
  const headers = LuxResolutionWorkflow_authHeaders()
  if (!headers) return false
  const res = await fetch(`${baseApiUrl}/api/impowerX/resolution-workflow-status`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ propertyHrId, resolutionRecordNumber, status }),
  })
  return res.ok
}

function LuxResolutionWorkflow_createSelect(
  propertyHrId,
  resolutionRecordNumber,
  currentStatus,
  onChange,
  options
) {
  LuxResolutionWorkflow_ensureSelectStyles()

  const fullWidth = options && options.fullWidth
  const useAntSelect = options && options.useAntSelect
  const wrap = document.createElement('div')
  wrap.className = 'lux-resolution-workflow-select-wrap'
  if (fullWidth) {
    wrap.style.width = '100%'
  } else {
    wrap.style.minWidth = '180px'
  }

  if (useAntSelect) {
    const { wrap: antWrap, ant, selectionItemEl } =
      LuxResolutionWorkflow_createAntSelectMimic(currentStatus)

    // Native select overlay for actual interactions
    const select = document.createElement('select')
    select.className = 'lux-resolution-ant-native-overlay'
    select.setAttribute('aria-label', 'Bearbeitungsstatus')

    LuxResolutionWorkflow.STATUSES.forEach(({ value, label }) => {
      const opt = document.createElement('option')
      opt.value = value
      opt.textContent = label
      select.appendChild(opt)
    })

    const effective =
      currentStatus && LuxResolutionWorkflow.STATUSES.some((s) => s.value === currentStatus)
        ? currentStatus
        : 'OPEN'
    select.value = effective
    selectionItemEl.textContent = LuxResolutionWorkflow_labelForStatus(effective)
    selectionItemEl.title = selectionItemEl.textContent

    select.addEventListener('change', async () => {
      if (select.disabled) return
      const next = select.value || 'OPEN'
      const ok = await LuxResolutionWorkflow_saveStatus(propertyHrId, resolutionRecordNumber, next)
      if (ok) {
        selectionItemEl.textContent = LuxResolutionWorkflow_labelForStatus(next)
        selectionItemEl.title = selectionItemEl.textContent
        if (typeof onChange === 'function') onChange(next)
      } else {
        console.error('Lux: could not save resolution workflow status')
      }
    })

    // Compose
    antWrap.appendChild(select)
    // Ensure sizing mirrors Ant input
    antWrap.style.width = '100%'
    ant.style.width = '100%'

    wrap.appendChild(antWrap)
    return wrap
  }

  const select = document.createElement('select')
  select.className = 'lux-resolution-ant-select-mimic lux-resolution-workflow-select'
  select.setAttribute('aria-label', 'Bearbeitungsstatus')
  if (fullWidth) {
    select.style.width = '100%'
  }

  LuxResolutionWorkflow.STATUSES.forEach(({ value, label }) => {
    const opt = document.createElement('option')
    opt.value = value
    opt.textContent = label
    select.appendChild(opt)
  })

  const effective =
    currentStatus && LuxResolutionWorkflow.STATUSES.some((s) => s.value === currentStatus)
      ? currentStatus
      : 'OPEN'
  select.value = effective

  select.addEventListener('change', async () => {
    if (select.disabled) return
    const next = select.value || 'OPEN'
    const ok = await LuxResolutionWorkflow_saveStatus(propertyHrId, resolutionRecordNumber, next)
    if (ok && typeof onChange === 'function') onChange(next)
    else if (!ok) console.error('Lux: could not save resolution workflow status')
  })

  wrap.appendChild(select)
  return wrap
}

/** Strip Bearbeitungsstatus suffix we previously injected, e.g. "Angenommen (In Bearbeitung)" → "Angenommen" */
function LuxResolutionWorkflow_stripStatusParenSuffix(text) {
  let t = (text || '').replace(/\s+/g, ' ').trim()
  LuxResolutionWorkflow.STATUSES.forEach(({ label }) => {
    const escaped = label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    const re = new RegExp(`\\s*\\(${escaped}\\)\\s*$`)
    t = t.replace(re, '').trim()
  })
  return t
}

function LuxResolutionWorkflow_cleanupLegacyBearbeitungColumn(table) {
  if (!table) return
  table.querySelectorAll('th.lux-resolution-workflow-header').forEach((el) => el.remove())
  table.querySelectorAll('td.lux-resolution-workflow-cell').forEach((el) => el.remove())
  table.querySelectorAll('col.lux-resolution-workflow-col').forEach((el) => el.remove())
}

/** /resolution-records/WEG00016 — Beschlusssammlung: append Bearbeitungsstatus into STATUS column */
const onResolutionRecordsListPageMatch = (pathname, regex) => {
  const m = pathname.match(regex)
  const propertyHrId = m && m[1]
  if (!propertyHrId) return

  let tbodyObserver = null
  let debounceTimer = null

  const findOverviewTable = () =>
    document.querySelector('.Page.ResolutionRecordOverview .ant-table-container') ||
    document.querySelector('[data-testid="page-content-undefined"] .ant-table-container') ||
    document.querySelector('.PageContent .ant-table-container')

  const applyStatusColumn = (table, statusMap) => {
    const theadRow = table.querySelector('thead.ant-table-thead tr:last-of-type')
    const tbody = table.querySelector('tbody.ant-table-tbody')
    if (!theadRow || !tbody) return

    const thEls = [...theadRow.querySelectorAll('th.ant-table-cell')]
    const statusColIndex = thEls.findIndex((th) => {
      const t = th.textContent.replace(/\s+/g, ' ').trim().toUpperCase()
      return t === 'STATUS'
    })
    if (statusColIndex < 0) return

    const lfdNrColIndex = thEls.findIndex((th) => {
      const t = th.textContent.replace(/\s+/g, ' ').trim().toUpperCase()
      return t === 'LFD.NR' || t === 'LFD. NR' || t === 'LFDNR'
    })

    const syncRow = (tr) => {
      const cells = [...tr.querySelectorAll('td.ant-table-cell')]
      if (cells.length <= statusColIndex) return

      // Prefer edit link, fallback to LFD.NR cell value
      let resolutionRecordNumber = null
      const editLink = tr.querySelector(
        `a[href*="/resolution-records/${propertyHrId}/edit/"]`
      )
      if (editLink) {
        const href = editLink.getAttribute('href') || ''
        const numMatch = href.match(/\/edit\/(\d+)\/?$/)
        if (numMatch) resolutionRecordNumber = numMatch[1]
      }

      if (!resolutionRecordNumber && lfdNrColIndex >= 0 && cells[lfdNrColIndex]) {
        const raw = (cells[lfdNrColIndex].textContent || '').trim()
        if (/^\d+$/.test(raw)) resolutionRecordNumber = raw
      }

      if (!resolutionRecordNumber) return
      const stored = statusMap[resolutionRecordNumber]

      const statusCell = cells[statusColIndex]

      const base = LuxResolutionWorkflow_stripStatusParenSuffix(statusCell.textContent)
      if (!base) return

      const shouldShow =
        stored === 'IN_PROGRESS' || stored === 'RESOLVED'

      let extra = ''
      if (shouldShow) {
        const entry = LuxResolutionWorkflow.STATUSES.find((s) => s.value === stored)
        extra = entry ? ` (${entry.label})` : ''
      }

      const nextText = base + extra

      if (statusCell.textContent.replace(/\s+/g, ' ').trim() !== nextText) {
        statusCell.textContent = nextText
      }
    }

    tbody.querySelectorAll('tr.ant-table-row').forEach((tr) => syncRow(tr))
  }

  const run = async () => {
    const table = findOverviewTable()
    if (!table) return

    LuxResolutionWorkflow_cleanupLegacyBearbeitungColumn(table)

    let statusMap = {}
    try {
      statusMap = await LuxResolutionWorkflow_fetchStatuses(propertyHrId)
    } catch (e) {
      console.error('Lux resolution list: fetch statuses', e)
      statusMap = {}
    }

    applyStatusColumn(table, statusMap)

    const tbody = table.querySelector('tbody.ant-table-tbody')
    if (tbody && !tbodyObserver) {
      tbodyObserver = new MutationObserver(() => {
        clearTimeout(debounceTimer)
        debounceTimer = setTimeout(() => {
          LuxResolutionWorkflow_fetchStatuses(propertyHrId)
            .then((map) => applyStatusColumn(table, map))
            .catch(() => {})
        }, 150)
      })
      tbodyObserver.observe(tbody, { childList: true })
    }
  }

  const obs = new MutationObserver(() => {
    run()
  })
  obs.observe(document.body, { childList: true, subtree: true })

  setTimeout(run, 400)
  setTimeout(run, 1500)
}

/** /resolution-records/WEG00016/edit/1 — single inject beside Beschlussstatus (same row) */
const onResolutionRecordsEditPageMatch = (pathname, regex) => {
  const m = pathname.match(regex)
  const propertyHrId = m && m[1]
  const resolutionRecordNumber = m && m[2]
  if (!propertyHrId || !resolutionRecordNumber) return

  let attempts = 0
  let inFlight = false

  const timer = setInterval(() => {
    attempts += 1
    if (attempts > 75) {
      clearInterval(timer)
      return
    }

    if (inFlight) return

    const statusLabels = [...document.querySelectorAll('.ant-form-item-label label')]
    const beschlussStatus = statusLabels.find((el) =>
      (el.textContent || '').includes('Beschlussstatus')
    )
    const inputRow = beschlussStatus && beschlussStatus.closest('.input-row')
    if (!inputRow || !inputRow.parentElement) return

    const beschlussSelectRoot = inputRow.querySelector('[data-testid="select-input-root-input"]')
    if (!beschlussSelectRoot) return

    const slot = beschlussSelectRoot.nextElementSibling
    if (!slot || !slot.classList.contains('input')) return

    if (slot.querySelector('.lux-resolution-workflow-bearbeitung')) {
      clearInterval(timer)
      return
    }

    inFlight = true

    LuxResolutionWorkflow_fetchStatuses(propertyHrId)
      .then((statusMap) => {
        if (!slot.isConnected) return
        if (slot.querySelector('.lux-resolution-workflow-bearbeitung')) {
          clearInterval(timer)
          return
        }

        const stored = statusMap[resolutionRecordNumber] || 'OPEN'

        // Mirror Beschlussstatus: .SelectInput.input > .ant-form-item (label + control) > … > control holds select
        const root = document.createElement('div')
        root.className = 'SelectInput input lux-resolution-workflow-bearbeitung'
        root.style.marginTop = '0'

        const formItem = document.createElement('div')
        formItem.className = 'ant-row ant-form-item'
        formItem.style.rowGap = '0px'
        formItem.style.marginBottom = '0px'

        const labelCol = document.createElement('div')
        labelCol.className = 'ant-col ant-form-item-label'
        const label = document.createElement('label')
        label.className = ''
        label.setAttribute('title', '')
        label.innerHTML = '<span><span>Bearbeitungsstatus</span></span>'
        labelCol.appendChild(label)

        const controlCol = document.createElement('div')
        controlCol.className = 'ant-col ant-form-item-control'
        const controlInput = document.createElement('div')
        controlInput.className = 'ant-form-item-control-input'
        const inner = document.createElement('div')
        inner.className = 'ant-form-item-control-input-content'

        const innerFormRow = document.createElement('div')
        innerFormRow.className = 'ant-row ant-form-item'
        innerFormRow.style.rowGap = '0px'
        innerFormRow.style.marginBottom = '0px'
        const innerControlCol = document.createElement('div')
        innerControlCol.className = 'ant-col ant-form-item-control'
        const innerControlInput = document.createElement('div')
        innerControlInput.className = 'ant-form-item-control-input'
        const innerMost = document.createElement('div')
        innerMost.className = 'ant-form-item-control-input-content'

        const selectWrap = LuxResolutionWorkflow_createSelect(
          propertyHrId,
          resolutionRecordNumber,
          stored,
          (next) => {
            statusMap[resolutionRecordNumber] = next
          },
          { fullWidth: true, useAntSelect: true }
        )
        innerMost.appendChild(selectWrap)

        const ourSelect = selectWrap.querySelector('select')
        const ourAntSelect = selectWrap.querySelector('.ant-select')
        LuxResolutionWorkflow_watchBeschlussLockState(beschlussSelectRoot, ourSelect, ourAntSelect)

        const beschlussRoot = inputRow.querySelector('.SelectInput')
        if (beschlussRoot) {
          beschlussRoot.style.flex = '1'
          beschlussRoot.style.minWidth = '0'
        }
        // The empty slot sometimes has padding that shifts contents down a bit
        slot.style.paddingTop = '0'
        slot.style.flex = '1'
        slot.style.minWidth = '0'
        innerControlInput.appendChild(innerMost)
        innerControlCol.appendChild(innerControlInput)
        innerFormRow.appendChild(innerControlCol)
        inner.appendChild(innerFormRow)

        controlInput.appendChild(inner)
        controlCol.appendChild(controlInput)

        formItem.appendChild(labelCol)
        formItem.appendChild(controlCol)
        root.appendChild(formItem)

        slot.innerHTML = ''
        slot.appendChild(root)
        clearInterval(timer)
      })
      .catch((e) => {
        console.error('Lux resolution edit: fetch statuses', e)
      })
      .finally(() => {
        inFlight = false
      })
  }, 200)
}
